import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import './Header.css';/* empty css            */
const HeaderBackButton = ({ onClick, label }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-header-back-button"), children: /* @__PURE__ */ jsx(Button, { type: "text", icon: /* @__PURE__ */ jsx(Icon, { name: "back" }), iconPosition: "left", iconGapSize: "normal", onClick, children: label }) });
};
export {
  HeaderBackButton as default
};
//# sourceMappingURL=HeaderBackButton.js.map
